import { makeColumns } from './structure_tool_renderer';
import { StructureTool } from './structure_tool';

export function onStructureReceiveForTable(structure_tool: StructureTool, entity: string, data: any, hiddenColumns: ReadonlyArray<string>, showingColumns: ReadonlyArray<string>,
    examples: any, filterModes: any, getdata: () => ReadonlyArray<any>,
    callback: (columns: Array<any>) => void,
    customFormatter: (field: string, value: any) => any, bundle: any,
    customFilterTranslator?: (key: string, value: string) => string, summaryCondition?: (row: any) => boolean) {
    const ent = data && data.hasOwnProperty(entity) ? data[entity] : null;
    // Helfer
    // Helfer ENDE
    // console.log('onStructureReceiveForTable ', entity, bundle);
    // console.log(ent);
    if (ent) {
        const atts: ReadonlyArray<any> = ent.ATTS;
        const columns = makeColumns(structure_tool, entity, atts, hiddenColumns, showingColumns, examples,
            filterModes, getdata, customFormatter, undefined, bundle,
            customFilterTranslator, summaryCondition);
        // console.log('structure_tool makeColumns columns :');
        // console.log(columns);
        callback(columns);
    } else {
        callback(null);
    }
}